import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';

import { forkJoin, of } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { TempLaminationService } from '@app/shared/services/temp-lamination.service';

@Component({
  selector: 'app-lamination-test',
  templateUrl: './lamination-test.component.html',
  styleUrls: ['./lamination-test.component.css']
})
export class LaminationTestComponent implements OnInit {

  tempLaminationForm: FormGroup;
  tickets = []; // Array to hold all ticket numbers
  rowCount: number = 1; // Default row count set to 1

  constructor(
    private formBuilder: FormBuilder,private Router:Router,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,private tempLaminationService:TempLaminationService, private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Fetch both repeat orders and unsaved orders
    forkJoin({
      // repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
      unsavedOrders: this.orderDataService.getAllUnsavedOrders(),
        repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    }).subscribe(response => {
      // Ensure the response objects are arrays, otherwise set them as empty arrays
      // const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];
      const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];
        const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];

      // Combine both orders into a single array (could also add custom properties to differentiate)
      // this.tickets = [...repeatOrders, ...unsavedOrders];
       this.tickets = [...unsavedOrders, ...repeatOrders];
       // Sort tickets in ascending order based on ticketNo
    // this.tickets.sort((a, b) => {
    //   const ticketNoA = a.ticketNo ? a.ticketNo : '';
    //   const ticketNoB = b.ticketNo ? b.ticketNo : '';
    //   return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    // });
    this.tickets.sort((a, b) => {
  const ticketNoA = a.ticketNo ? a.ticketNo : '';
  const ticketNoB = b.ticketNo ? b.ticketNo : '';
  return ticketNoA.localeCompare(ticketNoB);
}).reverse();


      this.cdr.detectChanges(); // This forces the UI to update after data is populated

      console.log("ticket",this.tickets);
    });
    
      // Initialize the form with a default single row
      this.tempLaminationForm = this.formBuilder.group({
        ticketNo: ['', Validators.required],
        jobName: ['', Validators.required],
        // width: ['', Validators.required],
        date: ['', Validators.required],


        refNo: ['', Validators.required],        // Add refNo
        poNumber: ['', Validators.required],      // Add poNumber
        std: ['', Validators.required],           // Add std
        clientName: ['', Validators.required],      // Add customer
        combinedMaterials: this.formBuilder.array([]), // Add combinedMaterials array (FormArray)



        material: ['', Validators.required],
        thickness: ['', Validators.required],
        width: ['', Validators.required],

        materialLam: ['', Validators.required],

        shift: ['', Validators.required],
        machine: ['', Validators.required],
        operator: ['', Validators.required],
        usedSize: ['', Validators.required],
        ip: ['', Validators.required],
        job: ['', Validators.required],
        rolls: ['', Validators.required],
        wastage: ['', Validators.required],

        ip2: ['', Validators.required],
        wastage2: ['', Validators.required],

        mix: ['', Validators.required],
        fresh: ['', Validators.required],
        returnn: ['', Validators.required],
        consumed: ['', Validators.required],  // We will update this dynamically

        ea: ['', Validators.required],
        ipa: ['', Validators.required],
        butonol: ['', Validators.required],
        tolune: ['', Validators.required],
        otherSol: ['', Validators.required],
        totalSol: ['', Validators.required],
        jco: ['', Validators.required],

        output: ['', Validators.required],
        thick: ['', Validators.required],


         ip1:['', Validators.required],
          thicknessMat:['', Validators.required],
           thicknessMat2:['', Validators.required],
      width2:['', Validators.required],
         plain:['', Validators.required],
    printed:['', Validators.required],
    laminated:['', Validators.required],
    otherWaste:['', Validators.required],
    totalWaste:['', Validators.required],


       
      });
        // Initially apply enteredRollNo to the first row if provided
    const enteredRollNo = this.tempLaminationForm.get('enteredRollNo')?.value;
    if (enteredRollNo) {
      const rowArray = this.tempLaminationForm.get('row') as FormArray;
      const firstRow = rowArray.at(0); // Get the first row
      firstRow.patchValue({
        rollNo: enteredRollNo  // Set the rollNo of the first row to enteredRollNo
      });
    }



    this.tempLaminationForm.valueChanges.subscribe(() => {
      this.calculateFormValues();
    });
  }
  // Method to create a new row (FormGroup)
 

onTicketSelect(event: any): void {
  const selectedTicketNo = event.target.value;
  if (selectedTicketNo) {
    const selectedTicket = this.tickets.find(ticket => ticket.ticketno === selectedTicketNo);
    if (selectedTicket) {
      // const width = selectedTicket.coilWidth || 'Default Width';
      const jobName = selectedTicket.jobName || 'Default Job Name';

      // const material = selectedTicket.combinedMaterials && selectedTicket.combinedMaterials.length > 0 
      // ? selectedTicket.combinedMaterials[0].material // Extracting the material from the first item
      // : 'Default Material'; // Default if no materials found

       
      // Filter combinedMaterials to get process === "PRINTING"
      const printingMaterial = selectedTicket.combinedMaterials
        ? selectedTicket.combinedMaterials.filter(material => material.process === "PRINTING")
        : [];

      // If there are any materials with process "PRINTING", pick the first one, else use default
      const material = printingMaterial.length > 0 
        ? printingMaterial[0].material 
        : ''; // Default if no material is found with process "PRINTING"
        const thickness = printingMaterial.length > 0 
        ? printingMaterial[0].thickness 
        : ''; // Default thickness if no printing material is found
      const width = printingMaterial.length > 0 
        ? printingMaterial[0].width 
        : ''; // Default width if no printing material is found



         // lamination
        // Filter combinedMaterials to get process === "LAMINATION"
const laminationMaterial = selectedTicket.combinedMaterials
? selectedTicket.combinedMaterials.filter(material => material.process === "LAMINATION")
: [];

// If there are any materials with process "LAMINATION", pick the first one, else use default
const materialLam = laminationMaterial.length > 0 
? laminationMaterial[0].material 
: ''; // Default if no material is found with process "LAMINATION"


        
      this.tempLaminationForm.patchValue({
      //  ticketNo: selectedTicket.ticketno,
       jobName: jobName,
      
       // date: selectedTicket.date,
        batch: selectedTicketNo,

        refNo: selectedTicket.refNo || 'Default Ref No',
        poNumber: selectedTicket.poNo || 'Default PO Number',
        clientName: selectedTicket.clientName || 'Default Client Name',
        // std: selectedTicket.std || 'Default STD',


        // material: material, // Setting the material here
        // thickness: thickness, // Setting the thickness here
        // width: width, // Setting the material width here

    

        // materialLam: materialLam, // Setting the material here
     
      });

        // Optionally populate the combinedMaterials array if available in the ticket
        if (selectedTicket.combinedMaterials) {
          this.setCombinedMaterials(selectedTicket.combinedMaterials);
        }
     
    }
  }
}



setCombinedMaterials(materials: any[]) {
  const combinedMaterialsFormArray = this.tempLaminationForm.get('combinedMaterials') as FormArray;

  // Clear any existing materials in the array before adding new ones
  combinedMaterialsFormArray.clear();

  materials.forEach(material => {
    combinedMaterialsFormArray.push(this.formBuilder.group({
      material: [material.material || ''],          
      density: [material.density || ''],            
      gsm: [material.gsm || ''],                    
      matRequired: [material.matRequired || ''],    
      netRm: [material.netRm || ''],                
      process: [material.process || ''],            
      thickness: [material.thickness || ''],        
      waste: [material.waste || ''],                
      width: [material.width || ''],                
      _id: [material._id || '']                     
    }));
  });
}


// Add a new material row
addMaterial(): void {
  const combinedMaterialsFormArray = this.tempLaminationForm.get('combinedMaterials') as FormArray;
  combinedMaterialsFormArray.push(this.formBuilder.group({
    material: [''],
    density: [''],
    gsm: [''],
    matRequired: [''],
    netRm: [''],
    process: [''],
    thickness: [''],
    waste: [''],
    width: [''],
    _id: ['']
  }));
}

// Remove a material row at a specific index
removeMaterial(index: number): void {
  const combinedMaterialsFormArray = this.tempLaminationForm.get('combinedMaterials') as FormArray;
  combinedMaterialsFormArray.removeAt(index);
}

getCombinedMaterialsControls() {
  return (this.tempLaminationForm.get('combinedMaterials') as FormArray).controls;
}











calculateFormValues(): void {
  const formData = this.tempLaminationForm.value;

  // Temporarily disable change detection to avoid unnecessary rerenders
  this.cdr.detach();

  // Calculate returnn as mix + fresh
  const fresh = parseFloat(formData.fresh) || 0;
  const mix = parseFloat(formData.mix) || 0;
  let returnn = 0;

  if (!isNaN(fresh) && !isNaN(mix)) {
    returnn = mix + fresh;  // Perform the calculation for returnn
  }

   // Calculate totalWaste as plain + printed + laminated + otherWaste
  // const plain = parseFloat(formData.plain);
  // const printed = parseFloat(formData.printed);
  // const laminated = parseFloat(formData.laminated);
  // const otherWaste = parseFloat(formData.otherWaste);
  const plain = parseFloat(formData.plain) || 0;
const printed = parseFloat(formData.printed) || 0;
const laminated = parseFloat(formData.laminated) || 0;
const otherWaste = parseFloat(formData.otherWaste) || 0;
  let totalWaste = 0;

  if (
    !isNaN(plain) &&
    !isNaN(printed) &&
    !isNaN(laminated) &&
    !isNaN(otherWaste)
  ) {
    totalWaste = plain + printed + laminated + otherWaste;
  }

  // Set the calculated returnn value to the form field if it has changed
  if (this.tempLaminationForm.get('returnn').value !== returnn) {
    this.tempLaminationForm.patchValue({ returnn });
  }

   // Set the calculated totalWaste value to the form field if it has changed
  if (this.tempLaminationForm.get('totalWaste').value !== totalWaste) {
    this.tempLaminationForm.patchValue({ totalWaste });
  }

  // Re-enable change detection after calculations
  this.cdr.reattach();
}






// for saving data
tempLamination() {
  console.log(this.tempLaminationForm.value);
  const formData = this.tempLaminationForm.value;

  // Prepare data object to save with all rows
  const dataToSave = {
    ticketNo: formData.ticketNo,
    jobName: formData.jobName,
    // width: formData.width,
    date: formData.date,



    refNo: formData.refNo,       // Add refNo
    poNumber: formData.poNumber,   // Add poNumber
    std: formData.std,     // Add std
    clientName: formData.clientName,

    material: formData.material,
    thickness: formData.thickness,
    width: formData.width,

    materialLam: formData.materialLam,

    shift: formData.shift,
        machine: formData.machine,
        operator: formData.operator,
        usedSize: formData.usedSize,

        ip: formData.ip,
        job: formData.job,

        rolls: formData.rolls,
        wastage: formData. wastage,

        ip2: formData.ip2,
        wastage2: formData. wastage2,

        jco: formData.jco,

        mix: formData.mix,
        fresh: formData.fresh,
        returnn: formData.returnn,
        consumed: formData.consumed,

        ea: formData.ea,
        ipa: formData.ipa,
        butonol: formData.butonol,
        tolune: formData.tolune,
        otherSol: formData.otherSol,
        totalSol: formData.totalSol,

        output: formData.output,
        thick: formData.thick,


         ip1: formData.ip1,
          thicknessMat: formData.thicknessMat,
           thicknessMat2: formData.thicknessMat2,
      width2: formData.width2,
         plain: formData.plain,
    printed: formData.printed,
    laminated: formData.laminated,
    otherWaste: formData.otherWaste,
    totalWaste: formData.totalWaste,

     
   
   
  };

  // Call the service to save data
  this.tempLaminationService.addTempLamination(dataToSave).subscribe(
    (response) => {
      console.log('Data saved successfully:', response);
      // Optionally reset form or perform other actions after successful save tempLaminationList
      this.Router.navigateByUrl('/laminationProdTable');  // This will redirect to the Table

    },
    (error) => {
      console.error('Error saving data:', error);
    }
  );
}

}
